import classNames from "classnames";

import styles from "./Media.module.css";

type PropTypes = {
  src: string;
  video?: boolean;
  controls?: boolean;
  full?: boolean;
  caption?: string;
  loop?: boolean;
};

/* eslint-disable @next/next/no-img-element */
const Media = ({ src, video = false, controls, full = false, caption, loop = false }: PropTypes) => {
  return (
    <div className={classNames(styles.media, { [styles.fullBleed]: full })}>
      {video ? (
        <figure>
          <div className={styles.mediaWrapper}>
            <video src={src} className={styles.video} controls={controls} autoPlay muted loop={loop} playsInline />
          </div>
          {caption ? <figcaption className={styles.caption}> {caption} </figcaption> : null}
        </figure>
      ) : (
        <figure>
          <div className={styles.mediaWrapper}>
            <img className={styles.image} src={src} alt={caption} />
            <figcaption className={styles.caption}> {caption} </figcaption>
          </div>
        </figure>
      )}
    </div>
  );
};
/* eslint-enable @next/next/no-img-element */

export default Media;
